"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isResponseStructureValid = isResponseStructureValid;

// eslint-disable-next-line import/prefer-default-export
function isResponseStructureValid(resp) {
  return !!(resp.body && resp.body.data && resp.body.data.attributes && resp.body.data.attributes.alerts && resp.body.data.attributes.browserSpecification);
}
//# sourceMappingURL=utils.js.map